const tr = {
  appointmentConfirmation: {
    attributes: {
      appointment_confirmation_enabled: 'Envio da confirmação',
      appointment_confirmation_template: 'Template da confirmação (Infobip)',
      appointment_confirmation_contact: 'Número de contato',
      patient_name: 'Paciente',
      phone: 'Celular',
      scheduled_at: 'Consulta',
      doctor_name: 'Profissional',
      specialty_name: 'Especialidade',
      status: 'Situação',
      skip_reason: 'Motivo',
      created_at: 'Marcado em',
      sent_at: 'Enviado em',
      delivered_at: 'Entregue em',
    },
    extras: {
      settingsTitle: 'Configuração',
      contactHelp: 'Ex.: (49) 3321-1000',
      saved: 'Configuração salva.',
      resultsTitle: 'Resultados',
      listTitle: 'Confirmações',
      createdFrom: 'Marcado de',
      createdUntil: 'Marcado até',
      statusFilter: 'Situação',
      statusAll: 'Todas as situações',
      resultStage: 'Etapa',
      resultTotal: 'Quantidade',
      reasonsTitle: 'Motivos de não envio',
      empty: 'Nenhuma confirmação no período.',
      results: {
        sent: 'Enviadas',
        delivered: 'Entregues',
        undelivered: 'Não entregues',
        waiting: 'Aguardando envio',
        failed: 'Falharam',
        skipped: 'Não enviadas',
      },
      statuses: {
        pending: 'Aguardando',
        sending: 'Enviando',
        sent: 'Enviada',
        delivered: 'Entregue',
        undelivered: 'Não entregue',
        failed: 'Falhou',
        skipped: 'Não enviada',
      },
      reasons: {
        disabled: 'Confirmação desligada',
        not_configured: 'Sem template ou contato',
        send_disabled: 'Envio bloqueado no servidor',
        past: 'Consulta já passou',
        outdated: 'Agendamento alterado',
        already_confirmed: 'Já confirmado',
        appointment_not_found: 'Consulta não encontrada',
        appointment_deleted: 'Consulta cancelada',
        not_scheduled: 'Consulta não está mais agendada',
        patient_not_found: 'Paciente não encontrado',
        foreign_prefix: 'Prefixo do país não é 55',
        no_phone: 'Sem celular',
        landline: 'Telefone fixo',
        invalid_phone: 'Celular inválido',
        invalid_ddd: 'DDD inválido',
        no_name: 'Sem nome',
        no_specialty: 'Sem especialidade',
        no_doctor: 'Sem profissional',
        opted_out: 'Pediu para não receber mensagens',
      },
    },
  },
};

export default tr;
